<template>
  <div class="aboutUs">
    <div class="carousel banner">
      <carousel :type="'minigame'"></carousel>
      <div class="layer">
        <img :src="logo" alt="">
      </div>
    </div>
    <div class="container about">
      <div class="item" id="aboutimage"></div>
      <div class="item">
        <span class="title upper">About ARCADIA GAMING</span>
        <span class="desc">
          Arcadia Gaming is a gaming brand managed by Arion Labs, a games development firm that aspires to develop cutting edge social gaming applications for the world. The team consists of enthusiastic professionals driven to innovate and develop the best games.
        </span>
        <span class="desc">
          Combining creative energy, in-depth experience and unsurpassed technical abilities, our team continuously delivers exhilarating experiences through unique and innovative games - Timeless games that are played by as many players as possible for many years to come.
        </span>
      </div>
    </div>
    <div class="container product">
      <div class="top">
        <div class="title capitalize">Our Products</div>
        <span class="desc">Arcadia Gaming supplies various online gaming platforms with our diverse portfolio of quality gaming solutions, specially curated to fit market needs based on collected data. As our content offering continues to grow, our selection of games are made available through a single point of integration. </span>
      </div>
      <div class="main">
        <productsCarousel></productsCarousel>
      </div>
    </div>

    <div class="container focus">
      <div class="title capitalize">Our Focus</div>
      <div class="main">
        <div class="item" v-for="item in focusItems">
          <div class="img">
            <img :src="item.image" alt="">
          </div>
          <div class="text">
            <span class="title" v-html="item.title"></span>
            <span class="desc" v-html="item.text"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const logo = require('@/assets/arcadialogo_footer.png');
const about = require('@/assets/about/about.png');

const focusicon1 = require('@/assets/about/focusicon1.png');
const focusicon2 = require('@/assets/about/focusicon2.png');
const focusicon3 = require('@/assets/about/focusicon3.png');
const focusicon4 = require('@/assets/about/focusicon4.png');
const focusicon5 = require('@/assets/about/focusicon5.png');
const focusicon6 = require('@/assets/about/focusicon6.png');
const focusicon7 = require('@/assets/about/focusicon7.png');
const focusicon8 = require('@/assets/about/focusicon8.png');
const focusicon9 = require('@/assets/about/focusicon9.png');

const aboutimage = require('@/assets/animation/game/aboutimage.json');

import carousel from '@/components/AboutUs/carousel'
import productsCarousel from '@/components/AboutUs/productsCarousel'


export default {
  name: "AboutUs",
  components: {carousel, productsCarousel},
  data() {
    return {
      logo: logo,
      about: about,
      focusItems: [
        {
          image: focusicon1,
          title: 'Curated Games',
          text: 'Adjustable product strategy based on data analysis to fit individual market needs',
        },
        {
          image: focusicon2,
          title: 'Engaging Team',
          text: 'Our team is full of passionate players and we only build games we love'
        },
        {
          image: focusicon3,
          title: 'Intuitive Designs',
          text: 'We place strong emphasis on UI/UX to deliver the best experience'
        },
        {
          image: focusicon4,
          title: 'Multi-platform',
          text: 'All of our games are delivered in HTML5 for flawless performance on any device'
        },
        {
          image: focusicon5,
          title: 'Data-driven<br>Development',
          text: 'We place strong emphasis on UI/UX to deliver the best experience'
        },
        {
          image: focusicon6,
          title: 'Multilingual ',
          text: 'We support most SEA languages currently and are ready to expand anytime'
        },
        {
          image: focusicon7,
          title: 'Fair Gaming ',
          text: 'All our games are RNG certified to ensure fairness '
        },
        {
          image: focusicon8,
          title: '24/7 Support',
          text: '24/7 support ensures our partners’ receives support anytime'
        },
        {
          image: focusicon9,
          title: 'Stable & Secured',
          text: 'Our games are hosted on high quality servers with strong security'
        },
      ],
      focusicon1: focusicon1,
      focusicon2: focusicon2,
      focusicon3: focusicon3,
      focusicon4: focusicon4,
      focusicon5: focusicon5,
      focusicon6: focusicon6,
      focusicon7: focusicon7,
      focusicon8: focusicon8,
      focusicon9: focusicon9,
      anis: [
        {
          name: 'aboutimage',
          type:'about',
          fileName:'aboutimage',
        },
      ],
    }
  },
  methods: {
    animation: function () {
      this.anis.forEach((i) => {
        var credentials = {
          type:i.type,
          file:i.fileName,
        }
        this.$store.dispatch('loadAni', {credentials: credentials}).then((res) => {
          let param = {
            container: document.getElementById(i.name),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: res.data
          };
          lottie.loadAnimation(param);
        })
      })
    }
  },
  mounted() {
    this.animation()
  },
}
</script>

<style lang="scss" scoped>
@import '../../style/aboutUs';
</style>
